import { useCombinedFieldStyles } from "@common/components/combinedField/CombinedField.styles";

// Room for the longest unit (Danish "Måned(er)") beside both the clear button and the dropdown arrow.
const unitWidth = 155;

export function useAutoRenewalDurationFieldStyles(isFilled: boolean) {
    return useCombinedFieldStyles(isFilled, "end", { addon: unitWidth });
}
